import React from 'react';
import { Route, IndexRoute } from 'react-router';

import CoreLayout from 'memo/layouts/CoreLayout';

import ChaptersPage from 'memo/pages/ChaptersPage';
import AddChapterPage from 'memo/pages/AddChapterPage';
import ParagraphPage from 'memo/pages/ParagraphPage';

export default (store, memo) => (
  <Route path="/" components={CoreLayout} memo={memo}>
    <IndexRoute component={ChaptersPage} />
    <Route path="chapters/new" component={AddChapterPage} />
    <Route path="chapters/:id/paragraphs/new" component={ParagraphPage} />
    <Route path="paragraphs/:paragraph" component={ParagraphPage} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/modules/memo/routes/index.js